module.exports = __webpack_public_path__ + "static/media/ios-bluetooth.b913deea.svg";